import React from "react";
import { ArrowUpRight, MapPin, Star } from "lucide-react";
import { heroImage, marqueeItems, studioInfo } from "../../mock";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const Marquee = () => {
  const items = [...marqueeItems, ...marqueeItems, ...marqueeItems, ...marqueeItems];
  return (
    <div className="relative w-full overflow-hidden border-y border-white/10 py-5 bg-[#0a0a0a]">
      <div className="onevo-marquee-track">
        {items.map((t, i) => (
          <span key={`${t}-${i}`} className="font-display text-2xl md:text-3xl text-white/90 mx-6 flex items-center">
            {t}
            <span className="text-white/30 ml-6">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

const Hero = () => {
  return (
    <section id="top" className="relative min-h-screen flex flex-col justify-end">
      <div className="absolute inset-0">
        <img src={heroImage} alt="ONEVO studio interior" className="w-full h-full object-cover" />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(10,10,10,0.75) 0%, rgba(10,10,10,0.55) 35%, rgba(10,10,10,0.85) 100%)",
          }}
        />
      </div>

      <div className="relative max-w-[1400px] mx-auto w-full px-6 md:px-10 pt-32 pb-16">
        <div className="flex flex-wrap items-center gap-6 mb-10">
          <span className="flex items-center gap-2 font-mono-label text-[11px] text-white/70">
            <MapPin size={14} /> Torino · Via Pastrengo 15
          </span>
          <span className="flex items-center gap-2 font-mono-label text-[11px] text-white/70">
            <Star size={14} className="fill-white text-white" /> {studioInfo.rating} · {studioInfo.reviews} recensioni Google
          </span>
        </div>

        <p className="font-mono-label text-[11px] text-white/50 mb-6">
          Premium Training Studio · {studioInfo.est}
        </p>

        <h1 className="font-display text-white text-[13vw] md:text-[8.5vw] leading-[0.9] max-w-[1100px] break-words">
          Allena il tuo{" "}
          <em className="not-italic" style={{ fontStyle: "italic", fontWeight: 800 }}>
            meglio.
          </em>{" "}
          <span className="text-white/45">Ogni giorno.</span>
        </h1>

        <p className="text-white/70 text-base md:text-lg max-w-[520px] mt-8 leading-relaxed">
          Un centro dove ogni dettaglio è pensato per te. Attrezzature Technogym di ultima
          generazione, ambienti curati al massimo e un team di esperti dedicati esclusivamente ai
          tuoi risultati.
        </p>

        <div className="flex flex-wrap gap-4 mt-10">
          <button
            onClick={() => scrollTo("contatti")}
            className="group inline-flex items-center gap-3 bg-white text-black font-mono-label text-[11px] px-8 py-4 rounded-[3px] hover:bg-white/85 transition-colors duration-300"
          >
            Prenota la consulenza
            <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
          <button
            onClick={() => scrollTo("servizi")}
            className="group inline-flex items-center gap-3 border border-white/25 text-white font-mono-label text-[11px] px-8 py-4 rounded-[3px] hover:bg-white/5 transition-colors duration-300"
          >
            Scopri i servizi
            <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </div>

        <p className="font-mono-label text-[10px] text-white/40 mt-12">
          Aperto Lun – Sab · Lun-Ven 06:00 — 21:00 · Sab 08:00 — 14:00
        </p>
      </div>

      <Marquee />
    </section>
  );
};

export default Hero;
